module.exports = __webpack_public_path__ + "static/media/arrow.fa45b587.svg";